import { render, staticRenderFns } from "./ModalAddon.vue?vue&type=template&id=23d0260c"
import script from "./ModalAddon.vue?vue&type=script&lang=js"
export * from "./ModalAddon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports